export enum EnsaioAliquotaLogResultadosEventsEnum {
  Alterado = 'ensaio-aliquota-log-resultados-alterado',
}
